module.exports = __webpack_public_path__ + "media/assets/icons/pagenavicon_column-a332a9395cd64eb9050f97f9239d3803.svg";